<template>
<div class="role-picker">
  <label for="user_role">
    Role
  </label>

  <select
    :name="selectName"
    id="selected_role_id"
    v-model="selected_role_id"
    class="form-control"
    v-on:change="changed"
  >
    <option
      value=""
    >
      Select Role
    </option>
    <option
      :selected="isSelected(role.id)"
      :value="role.id"
      v-for="role in roles"
    >
      {{ role.name }}
    </option>
  </select>
</div>
</template>

<script>
export default {
  data () {
    return {
      selected_role_id: undefined,
      roles: []
    }
  },

  props: [
    'selectName', 'roleId'
  ],

  computed: {
    firstRoleOption () {
      return document.querySelector('#selected_role_id option')
    }
  },

  mounted () {
    this.selected_role_id = this.roleId

    if (!this.selected_role_id) {
      this.setDefaultRoleOption()
    }

    this.get()
  },

  methods: {
    changed () {
      this.$parent.$emit('roleChanged', this.selected_role_id)
    },

    isSelected (roleId) {
      return roleId === this.role_id
    },

    get () {
      this.$http.get(this.apiUrl('/objects/role?page[order_by]=name', true)).then((response) => {
        this.roles = response.body
      }, this.processErrors)
    },

    setDefaultRoleOption () {
      this.firstRoleOption.setAttribute('selected', true)
      this.selected_role_id = this.firstRoleOption.id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RolePicker.vue